"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var qrious = require('qrious');
var Qr = function (props) {
    if (typeof window === 'undefined')
        return null;
    var base64 = new qrious({
        value: props.url,
        size: 100,
    }).toDataURL();
    return (React.createElement("img", { src: base64 }));
};
exports.default = Qr;
